import { render, staticRenderFns } from "./DocumentosOriginales.vue?vue&type=template&id=71a2204a"
import script from "./DocumentosOriginales.vue?vue&type=script&lang=js"
export * from "./DocumentosOriginales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71a2204a')) {
      api.createRecord('71a2204a', component.options)
    } else {
      api.reload('71a2204a', component.options)
    }
    module.hot.accept("./DocumentosOriginales.vue?vue&type=template&id=71a2204a", function () {
      api.rerender('71a2204a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/procesos/notificaciones/completaInfo/DocumentosOriginales.vue"
export default component.exports